import { render, staticRenderFns } from "./UnitViewModal.vue?vue&type=template&id=37ea0a7c&scoped=true"
import script from "./UnitViewModal.vue?vue&type=script&lang=js"
export * from "./UnitViewModal.vue?vue&type=script&lang=js"
import style0 from "./UnitViewModal.vue?vue&type=style&index=0&id=37ea0a7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ea0a7c",
  null
  
)

export default component.exports